export const ResponsiveSwitching = {
  extends: 'NavbarButtonSet',
  gap: 'A',
  scope: { previewSize: null },
  childrenAs: 'state',
  children: () => [
    { key: 'screenL', icon: 'deviceBigScreen' },
    { key: 'screenM', icon: 'deviceSmallScreen' },
    { key: 'tabletL', icon: 'deviceTabletLandscape' },
    { key: 'tabletS', icon: 'deviceTabletPortrait' },
    { key: 'mobileXS', icon: 'deviceMobile' },
    { key: 'canvas', icon: 'columns' },
    { key: 'custom', icon: 'layout' },
    { key: 'resizable', icon: 'dimensionsAlt' }
  ],
  childProps: {
    isActive: (el, s) => el.parent.scope?.previewSize === s.key,

    icon: (el, s) => {
      const active = el.parent.scope?.previewSize === s.key
      return active ? s.icon : s.icon + ' outline'
    },

    title: (el, s) => s.key,

    '.isActive': {
      theme: 'navbarButton-active'
    },

    '!isActive': {
      theme: 'navbarButton'
    },

    onClick: (ev, el, s) => {
      const parent = el.parent
      const scope = parent.scope
      if (!scope) return
      const newSize = scope.previewSize !== s.key ? s.key : null
      // Reactive scope write — fires signals on parent.scope.previewSize
      // so all sibling icon factories re-evaluate their `isActive` /
      // theme bindings automatically (smbls FRAMEWORK-SCOPE-REACTIVE-1).
      scope.previewSize = newSize
      // The icon-sprite swap is imperative DOM (no DOMQL binding for
      // xlink:href on individual children), so we still need a sibling
      // walk for THAT specific render — but no longer need `child.update()`
      // afterwards; the reactive theme/.isActive bindings cover the rest.
      for (const key of parent.__ref.__children) {
        const child = parent[key]
        if (!child?.Icon?.node) continue
        const isActive = child.state.key === newSize
        const iconBase = child.state.icon
        const outlineId = iconBase + 'Outline'
        const hasOutline = !!document.getElementById(outlineId)
        const spriteId = isActive ? iconBase : (hasOutline ? outlineId : iconBase)
        const useEl = child.Icon.node.querySelector('use')
        if (useEl) useEl.setAttribute('xlink:href', '#' + spriteId)
      }
      if (el.syncCanvas) el.syncCanvas({ previewSize: newSize })
    }
  }
}
